App.StackedBarChartComponent = Em.Component.extend
  classNames: ['stacked-bar-chart']
  env: Em.inject.service('environment')

  # Обязательные поля
  labels: null              # Объект в котором: ключи - машинные поля, значения - человекочиатемые
  data: null                # Основной массив данных
  xAxisKey: null            # Название ключа по которому выводиться шкала xAxis

  # Второстипенные
  columnFormat: 'absolute'  # Формат колонок, может быть: absolute, percent
  width: 960
  height: 500

  xAxisRotate: null         # Градус на который будет повернуты подписы по оси x, часто подходит -65

  yAxisLabel: null          # Подпись оси y

  marginTop: 10            # Отступы внутри графика
  marginRight: 20
  marginBottom: 20
  marginLeft: 40

  duration: 750             # Время анимации, в секундах

  legendIsShown: false      # Показывать ли легенду
  showDifferenceData: false # Показывать только разницу в графике

  chartWidth: Ember.computed(
    'width',
    'marginRight',
    'marginLeft',
    ->
      width = @get('width') - @get('marginRight') - @get('marginLeft')

      if width < 0
        width = 0

      width
  )

  chartHeight: Ember.computed(
    'height',
    'marginTop',
    'marginBottom',
    ->
      height = @get('height') - @get('marginTop') - @get('marginBottom')

      if height < 0
        height = 0

      height
  )

  svgData: Ember.computed(
    'data',
    'columnFormat',
    'labels',
    'showDifferenceData',
    ->
      data = @get('data')
      columnFormat = @get('columnFormat')
      labels = @get('labels')
      showDifferenceData = @get('showDifferenceData')

      labels = labels.slice().reverse()

      if columnFormat is 'absolute'
        data.forEach (d) ->
          y0 = 0
          d._values = labels.map (item) ->
            {
              name: item.key,
              y0: y0,
              y1: y0 += +d[item.key]
              color: item.color
            }

          d._total = d._values[d._values.length - 1].y1
          d._diffLimit = d._values[0].y1 - ((d._total - d._values[0].y1) * 0.15)

      if columnFormat is 'percent'
        data.forEach (d) ->
          y0 = 0
          summa = 0

          labels.forEach (item) ->
            summa += +d[item.key]

          d._values = labels.map (item) ->
            {
              name: item.key,
              y0: y0,
              y1: y0 += parseFloat(+d[item.key] / summa * 100)
              color: item.color
            }

          d._total = 100
          d._diffLimit = d._values[0].y1 - ((d._total - d._values[0].y1) * 0.15)

      if showDifferenceData
        diffLimit = d3.min(data, (d) -> d._diffLimit)
        data.forEach (d) ->
          d._values[0].y0 = d._values[0].y0 + diffLimit

      data
  )

  xScale: Ember.computed(
    'xAxisKey',
    'yAxisLabel',
    'svgData',
    'chartWidth',
    ->
      xAxisKey = @get('xAxisKey')
      yAxisLabel = @get('yAxisLabel')
      svgData = @get('svgData')
      chartWidth = @get('chartWidth')

      xStart = if yAxisLabel then 20 else 0

      d3.scale.ordinal()
        .domain(svgData.map((d) -> d[xAxisKey]))
        .rangeRoundBands([xStart, chartWidth], 0.05, 0)
  )

  yScale: Ember.computed(
    'svgData',
    'chartHeight',
    'showDifferenceData',
    ->
      svgData = @get('svgData')
      chartHeight = @get('chartHeight')
      showDifferenceData = @get('showDifferenceData')

      minValue = if showDifferenceData then d3.min(svgData, (d) -> d._diffLimit) else 0
      maxValue = d3.max(svgData, (d) -> d._total)

      d3.scale.linear()
        .domain([minValue, maxValue])
        .range([chartHeight, 0])
  )

  xAxis: Ember.observer(
    'xScale',
    'svg',
    'xAxisRotate',
    'chartHeight',
    'duration',
    ->
      svg = @get('svg')
      xAxisRotate = @get('xAxisRotate')
      xScale = @get('xScale')
      chartHeight = @get('chartHeight')
      duration = @get('duration')

      xAxis = d3.svg.axis()
        .scale(xScale)
        .orient("bottom")
        .tickFormat(d3.ru_RU.timeFormat('%d %b'))

      # Помещается только 14 подписей при ширине графика в 900px
      if xScale.domain().length > 14
        countTicks = Math.ceil(xScale.domain().length / 14)
        countIndent = Math.floor(countTicks / 2)

        xAxis.tickValues(xScale.domain().filter((d, i) ->
          !((i - countIndent) % countTicks)
        ))

      # Обновляем существующий или создаем новый
      if svg.select('.svg-main').select(".x.axis").size()
        svg.select(".x.axis")
          .transition()
          .duration(duration)
            .attr("transform", "translate(0," + chartHeight + ")")
            .call(xAxis)
      else
        xAxisEl = svg.select('.svg-main').append("g")
          .attr("class", "x axis")
          .attr("transform", "translate(0," + chartHeight + ")")
          .call(xAxis)

        if !Ember.isEmpty(xAxisRotate)
          xAxisEl.selectAll("text")
            .style("text-anchor", "end")
            .attr("dx", "-.8em")
            .attr("dy", ".15em")
            .attr("transform", "rotate(#{xAxisRotate})")
  ).on('svgReady')

  yAxis: Ember.observer(
    'yScale',
    'svg',
    'yAxisLabel',
    'chartHeight',
    'duration',
    ->
      yScale = @get('yScale')
      svg = @get('svg')
      yAxisLabel = @get('yAxisLabel')
      chartHeight = @get('chartHeight')
      duration = @get('duration')

      yAxis = d3.svg.axis()
        .scale(yScale)
        .orient("left")
        .tickFormat(d3.format(".2s"))

      # Высчитываем сколько поместиться в высоту без пересеканий,
      # лишние убираем, берем в расчет что одна строка - 15px в высоту
      yAxis.ticks(Math.ceil(chartHeight / 15))

      # Обновляем существующий или создаем новый
      if svg.select('.svg-main').select(".y.axis").size()
        svg.select(".y.axis")
          .transition()
          .duration(duration)
          .call(yAxis)
      else
        yAxisEl = svg.select('.svg-main').append("g")
          .attr("class", "y axis")
          .call(yAxis)

        if !Ember.isEmpty(yAxisLabel)
          yAxisEl.append("text")
            .attr("transform", "rotate(-90)")
            .attr("y", 6)
            .attr("dy", ".71em")
            .style("text-anchor", "end")
            .text(yAxisLabel)
  ).on('svgReady')

  columns: Ember.observer(
    'svg',
    'svgData',
    'chartHeight',
    'xScale',
    'yScale',
    'xAxisKey',
    'duration',
    ->
      svg = @get('svg')
      svgData = @get('svgData')
      chartHeight = @get('chartHeight')
      xScale = @get('xScale')
      yScale = @get('yScale')
      xAxisKey = @get('xAxisKey')
      duration = @get('duration')

      columns = svg.select('.svg-main').selectAll(".chart-columns")

       # Join
      chartColumns = columns.selectAll(".chart-column").data(svgData)
      chartColumns.selectAll("rect").data((d) -> d._values )

      # Update
      chartColumns
        .transition()
          .duration(duration)
            .attr("transform", (d) -> "translate(#{xScale(d[xAxisKey])},0)")

      chartColumns.selectAll("rect")
        .transition()
          .duration(duration)
            .attr("width", xScale.rangeBand())
            .style("fill", (d) -> d.color )
            .attr("y", (d) -> yScale(d.y1) )
            .attr("height", (d) -> yScale(d.y0) - yScale(d.y1) )

      # Create
      chartColumns.enter().append("g")
        .attr("class", "chart-column")
        .attr("height", chartHeight)
        .attr("transform", (d) -> "translate(#{xScale(d[xAxisKey])},0)")

      chartColumns
        .selectAll("rect")
        .data((d) -> d._values )
        .enter().append("rect")
          .attr("width", xScale.rangeBand())
          .attr("y", chartHeight )
          .attr("height", 0 )
          .style("fill", (d) -> d.color )
          .transition()
            .duration(duration)
              .attr("y", (d) -> yScale(d.y1) )
              .attr("height", (d) -> yScale(d.y0) - yScale(d.y1) )

      # Destroy
      chartColumns
        .exit()
        .transition()
          .duration(duration / 2)
          .style("fill-opacity", 1e-6)
          .remove()

      chartColumns
        .selectAll("rect")
        .data((d) -> d._values )
          .exit()
          .remove()


      # Обработки событий
      chartColumns.on 'click', (d) =>
        @sendAction 'onClickColumn', d

      chartColumns.on 'mouseenter', (d) =>
        @sendAction 'onMouseEnterColumn', d

      chartColumns.on 'mouseleave', (d) =>
        @sendAction 'onMouseLeaveColumn', d
  ).on('svgReady')

  legends: Ember.observer(
    'svg',
    'labels',
    'chartWidth',
    'legendIsShown',
    'duration',
    ->
      svg = @get('svg')
      labels = @get('labels')
      chartWidth = @get('chartWidth')
      legendIsShown = @get('legendIsShown')
      duration = @get('duration')

      return unless legendIsShown

      # Квадраты
      colors = labels.mapBy 'color'

      if colors.length
        legendsRect = svg.select('.svg-main').selectAll(".legend-rect").data(colors, (d) -> d)

        legendsRect.enter()
          .append("rect")
            .attr("class", "legend-rect")
            .attr("transform", (d, i) -> "translate(0," + (i * 20 + 20) + ")" )
            .attr("x", chartWidth + 4)
            .attr("y", 0)
            .attr("width", 18)
            .attr("height", 18)
            .style("fill", (d, i) -> d)

        legendsRect
          .attr("transform", (d, i) -> "translate(0," + (i * 20 + 20) + ")" )
          .style("fill", (d) -> d)

        legendsRect.exit().remove()

      # Подписи
      captions = labels.mapBy 'label'

      if captions.length
        legendsLabels = svg.select('.svg-main').selectAll(".legend-label").data(captions, (d) -> d)

        legendsLabels.enter()
          .append("text")
            .attr("class", "legend-label")
            .attr("x", chartWidth + 28)
            .attr("y", (d, i) -> i * 20 + 20 + 9)
            .attr("dy", ".35em")
            .style("text-anchor", "start")
            .text((d) -> d )

        legendsLabels
            .attr("x", chartWidth + 28)
            .attr("y", (d, i) -> i * 20 + 20 + 9)
            .text((d) -> d )

        legendsLabels.exit().remove()
  ).on('svgReady')

  svgObserver: Ember.observer(
    'width',
    'height',
    'chartWidth',
    'chartHeight',
    'marginLeft',
    'marginTop',
    'marginBottom',
    'marginRight',
    'duration',
    ->
      width = @get('width')
      height = @get('height')

      chartWidth = @get('chartWidth')
      chartHeight = @get('chartHeight')

      marginLeft = @get('marginLeft')
      marginTop = @get('marginTop')
      marginBottom = @get('marginBottom')
      marginRight = @get('marginRight')

      duration = @get('duration')

      # Главный контейнер
      svg = @get('svg')

      unless svg
        svg = d3.select(@$().get(0))
          .append("svg")

        svg.append("g")
          .attr("class", "svg-main")
          .append("g")
            .attr("class", "chart-columns")

      svg
        .transition()
          .duration(duration)
            .attr("width", width)
            .attr("height", height)

      svg.select('.svg-main')
        .attr("transform", "translate(" + marginLeft + "," + marginTop + ")")

      svg.select('chart-columns')
        .attr("height", chartHeight)

      if @get('svg')
        @set('svg', svg)
      else
        @set('svg', svg)
        @trigger('svgReady')
  ).on('didInsertElement')

  destroySvg: (->
    d3.select(@$('svg').get(0)).remove()
  ).on('willDestroyElement')